import React from 'react'
import { StyledIcon } from '../StyledIcon'

const MapIcon = ({ icon, size, customProps }) => (
  <StyledIcon
    viewBox="0 0 585 1024"
    a11yTitle={icon}
    color="plain"
    size={size}
    {...customProps}
  >
    <path d="M438.857 374.857c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM585.143 374.857c0 34.857-4 70.857-18.857 102.286l-208 442.286c-12 25.143-38.286 40.571-65.714 40.571s-53.714-15.429-65.143-40.571l-208.571-442.286c-14.857-31.429-18.857-67.429-18.857-102.286 0-161.714 130.857-292.571 292.571-292.571s292.571 130.857 292.571 292.571z" />
  </StyledIcon>
)

export default MapIcon
